import Footer from 'navigation/components/Footer';
import Header from 'navigation/components/Header';
import React from 'react';

const WithHeaderAndFooter = (Component) => {
    return (props) => (
      <div>
        <Header />
        <Component {...props} />
        <React.Suspense fallback={<Footer noLink />}>
            <Footer />
          </React.Suspense>
      </div>
    );
  };
  
  export default WithHeaderAndFooter;